<template>
  <portal to="modal">
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" ref="modal">
      <div :class="[
        'modal-dialog',
        size ? 'modal-' + size : '',
        ]" role="document">
        <div class="modal-content">
          <slot name="header">
            <div class="modal-header" v-if="title">
              <h5 class="modal-title">{{ title }}</h5>
              <button type="button" class="close" aria-label="Close" @click.prevent="$emit('hide')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </slot>
          <div class="modal-body">
            <slot></slot>
          </div>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  name: "Modal",
  props: {
    show: {
      default : false,
    },
    title: {
      required: false,
      default: null,
    },
    size: {
      required: false,
      default: null,
      validate(value) {
        return ['sm', 'lg', 'xl'].includes(value);
      }
    },
  },
  watch: {
    show(value) {
      if(value) {
        $(this.$refs.modal).modal('show');
      } else {
        $(this.$refs.modal).modal('hide');
      }
    },
  },
  methods: {
    initModal() {
      $(this.$refs.modal).modal({
        show: this.show,
        keyboard: false,
        backdrop: 'static',
      });
      $(this.$refs.modal)
        .on('show.bs.modal', () => {
          this.$emit('show', this.$refs.modal)
        })
        .on('shown.bs.modal', () => {
          this.$emit('shown', this.$refs.modal)
        })
        .on('hide.bs.modal', () => {
          this.$emit('hide', this.$refs.modal)
        })
        .on('hidden.bs.modal', () => {
          this.$emit('hidden', this.$refs.modal)
        })
        .on('hidePrevented.bs.modal', () => {
          this.$emit('hidePrevented', this.$refs.modal)
        })
    }
  },
  mounted() {
    // use nextTick to deal with portal rendering
    this.$nextTick(() => {
      this.initModal();
    });
  },
}
</script>

<style scoped>

</style>